import {
  ME_URL,
  ME_URL_V2,
  LOGIN_URL,
  LOGOUT_URL,
  REGISTER_URL,
  PASSWORD_RESET_URL,
  PASSWORD_RESET_LOGIN_URL,
  PASSWORD_UPDATE_URL,
  GET_STORY_URL
} from 'shared/utils/Constants';

import { get, post, put, destroy } from 'shared/services/ApiService';

import { print, printError } from 'shared/utils/Helpers';
import User from 'shared/data/User';

// todo - nix the class
export default class UserService {

  constructor() {
    this.user_types = {
      'Regular': 'Regular',
    };
  }

  // API CALLS

  async me() {
    return get(ME_URL)
      .then(user => {
        User.instance.save(user);
        return Promise.resolve(user);
      })
      .catch(() => {
        return Promise.resolve(null);
      });
  }

  async signInWithCredentials(email, password) {
    const params = {
      "email": email,
      "password": password,
    }

    return await post(LOGIN_URL, params).
      then(resp => {
        User.instance.save(resp);
        return Promise.resolve(resp);
      }).catch(resp => {
        if ("error" in resp) {
          return Promise.reject(resp["error"]);
        }
      });
  }

  async logout() {
    let resp = await get(LOGOUT_URL);
    return Promise.resolve(resp);
  }

  async register(email, password) {
    var params = {
      "email": email,
      "password": password,
    }
    // var formBody = this.urlEncodeParams(params);
    //console.log(formBody);
    let response = await fetch(REGISTER_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: params
    });

    let responseJson = await response.json();
    try {
      print("register response", responseJson);
      // localStorage.setItem('loggedInUser', JSON.stringify(responseJson));
      return responseJson;
    } catch (error) {
      printError("register error");
      printError(error);
      alert("Error. Cannot connect to server.")
    }
  }

  getUser() {
    let data = localStorage.getItem('loggedInUser');
    if (data) {
      return JSON.parse(data);
    }
    return {};
  }

  getAuthToken() {
    var loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"));
    if (loggedInUser && loggedInUser.token) {
      return loggedInUser.token;
    }
    return "";
  }

  requestPasswordReset(params) {
    return post(PASSWORD_RESET_URL, params);
  }

  passwordResetLogin(params) {
    return post(PASSWORD_RESET_LOGIN_URL, params);
  }

  updatePassword(params) {
    return put(PASSWORD_UPDATE_URL, params);
  }

  async getAccessCode() {
    let stories = await get(GET_STORY_URL);

    if (stories.length == 0) {
      throw 'no story';
    }
    var story = stories.find((x) => { return x.access_code !== "" });

    const accessCode = story ? story.access_code : '';
    return Promise.resolve(accessCode);
  }

  setLocale(locale) {
    return put(ME_URL_V2, { locale });
  }
}
